module.exports = __webpack_public_path__ + "media/images/CLEVAS_back-adb899d6.png";